<template>
    <div id="ExportTotalLast12Months" :style="{ height: '100%' }"></div>
</template>
<script>
import { lsdRegionTradeStatIndex } from '@/api/home.js';
import { getLast12FullData } from '@/utils/tools.js'
import { arrData } from '@/utils/data.js'
import { buildDynamicCompareData ,formatNumber} from '@/utils/tools.js'

export default {
    name: "",
    components: {},
    props: ['intervalRefreshDate'],
    data() {
        return {
            timer: null,
            arrData: [],
            dataItems: []
        };
    },
    watch: {},
    computed: {},
    methods: {
        async initData() {
            // 获取当前月份 YYYY-MM
            const now = new Date();
            const endYear = now.getFullYear();
            const endMonth = String(now.getMonth() + 1).padStart(2, '0');
            const dateEnd = `${endYear}-${endMonth}`;

            // 往前推 11 个月（总共为 12 个月）
            const startDate = new Date(endYear, now.getMonth() - 34, 1);
            const startYear = startDate.getFullYear();
            const startMonth = String(startDate.getMonth() + 1).padStart(2, '0');
            const dateStart = `${startYear}-${startMonth}`;

            try {
                const res = await lsdRegionTradeStatIndex({
                    queryType: 'CUSTOM_RANGE',
                    dateStart,
                    dateEnd,
                });
                this.arrData = res.data;
                await this.drawLine();
            } catch (err) {
            }
        },
        getLast12FullData,
        async drawLine() {
            // 基于刚刚准备好的 DOM 容器，初始化 EChart 实例
            let myChart = this.$echarts.init(document.getElementById('ExportTotalLast12Months'))
            // 绘制图表
            let monthData = [];
            const arr = this.getLast12FullData(this.arrData)
            this.dataItems = arr;
            let xAxisData = [];//月份
            arr.forEach(item => {
                monthData.push(item.exportValue)
                xAxisData.push(item.month + '月')
            });



            const total = monthData.reduce((sum, val) => sum + val, 0);

            // 计算总数
            var option = {
                title: {
                    text: `出口总数：${formatNumber(total)} 万元`, // ✅ 动态显示总和


                    textStyle: {
                        align: 'center',
                        color: '#9FC7DD',
                        fontSize: 14,
                    },
                    top: '4',
                    left: '2',
                },

                tooltip: {
                    trigger: 'axis',
                    formatter: (e) => {
                        const index = e[0].dataIndex;
                        const item = this.dataItems[index];
                        const date = `${item.year}年${item.month}月`;
                        return ` 
                        <div>${date}</div>
                        出口量: <span style="font-weight:500;">${formatNumber(item.exportValue)}</span> 
                        `;
                    },
                    axisPointer: {
                        lineStyle: {
                            color: {
                                type: 'linear',
                                x: 0,
                                y: 0,
                                x2: 0,
                                y2: 1,
                                colorStops: [
                                    { offset: 0, color: 'rgba(0, 255, 233,0)' },
                                    { offset: 0.5, color: 'rgba(255, 255, 255,1)' },
                                    { offset: 1, color: 'rgba(0, 255, 233,0)' }
                                ],
                                global: false
                            }
                        },
                    },
                },
                grid: {
                    top: '25%',
                    left: '13%',
                    right: '4%',
                    bottom: '15%',
                },
                xAxis: [{
                    type: 'category',
                    axisLine: { show: true },
                    axisLabel: { color: '#96A9BA' },
                    splitLine: { show: false },
                    boundaryGap: false,
                    // data: ['1月', '2月', '3月', '4月', '5月', '6月', '7月', '8月', '9月', '10月', '11月', '12月'],
                    data: xAxisData,
                }],
                yAxis: [{
                    type: 'value',
                    min: 0,
                    splitNumber: 4,
                    splitLine: {
                        show: true,
                        lineStyle: {
                            color: 'rgba(255,255,255,0.1)',
                            type: 'dashed', // ✅ 设置为虚线

                        }
                    },
                    axisLine: { show: false },
                    axisLabel: {
                        show: true,
                        color: '#96A9BA', // 字体颜色
                    },
                    axisTick: { show: false },
                }],
                series: [
                    {
                        name: '出口量',
                        // show: false,
                        type: 'line',
                        smooth: true,
                        showAllSymbol: true,
                        symbol: 'circle',
                        // symbolSize: 10,
                        // ✅ 控制显示点：只在 2月(索引1)、5月(索引4)、8月(索引7)、11月(索引10) 显示点
                        symbolSize: function (value, params) {
                            const showIndex = [1, 4, 7, 10];
                            return showIndex.includes(params.dataIndex) ? 10 : 0;
                        },
                        lineStyle: {
                            width: 3,
                            color: "#00b3f4",
                            shadowColor: 'rgba(0, 0, 0, .1)',
                            shadowOffsetY: 1,
                            shadowOffsetX: 1,
                        },
                        label: {
                            show: false,
                            position: 'top',
                            color: '#00b3f4'
                        },
                        itemStyle: {
                            color: '#fff', // 中心白色
                            borderColor: 'rgba(0,179,244,0.6)', // 外圈透明蓝
                            borderWidth: 8, // 外圈大小
                            shadowBlur: 10,
                            shadowColor: 'rgba(0,179,244,0.8)', // 光晕颜色
                        },
                        tooltip: { show: true },
                        areaStyle: {
                            color: this.$echarts.graphic.LinearGradient(0, 0, 0, 1, [
                                { offset: 0, color: '#40AFEF' },
                                { offset: 1, color: 'rgba(0,179,244,0.2)' }
                            ]),
                            shadowColor: 'rgba(0,179,244, 0.1)',
                            shadowBlur: 20
                        },
                        data: monthData
                    }
                ]
            };

            myChart.clear();
            myChart.setOption(option);
        }
    },
    created() { },
    async mounted() {
        await this.initData();

        // this.timer = setInterval(async () => {
        //     await this.drawLine();
        // }, this.intervalRefreshDate)


    },
    beforeDestroy() {
        console.log("销毁定时器")
        //2.销毁前清除定时器
        clearInterval(this.timer);
    },
}
</script>
<style lang="scss" scoped></style>